import React from "react";
//#region types
import { DialogProps } from "models/propTypes/dialogPropTypes";
//#endregion
//#region components
import FullScreenView from "./_fullscreenView";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const ImageZoomDialog: React.FC<DialogProps> = (props) => {
  return <FullScreenView {...props} classes={{ dialogRoot: cssExports.imageZoomDialogRoot }} />;
};

export default ImageZoomDialog;
